// Simple, consistent API configuration
const getApiUrl = () => {
  // ALWAYS use /api prefix since backend ALWAYS has setGlobalPrefix('api')
  // This keeps localhost and production behavior identical
  
  if (typeof window !== 'undefined') {
    // For www subdomain, redirect to non-www with /api
    if (window.location.hostname === 'www.embassyoflifechapel.org') {
      return 'https://embassyoflifechapel.org/api';
    }
    
    // For localhost or any other domain, use same origin + /api
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    const port = hostname === 'localhost' ? ':5001' : '';
    
    return `${protocol}//${hostname}${port}/api`;
  }
  
  // Fallback for server-side rendering
  return (process.env.REACT_APP_API_URL || 'https://embassyoflifechapel.org') + '/api';
};

export const API_URL = getApiUrl(); 